

import React from 'react';
import { withRouter } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import RequestProvider from '../../RequestProvider';
import { getLandingPageAnalyticsQuery } from '../queries';
import AnalyticsBannerComponent from '../components/AnalyticsBanner';








function AnalyticsBanner(props) {
  return (
    <AuthorisationConsumer>
      {({ selectedOrganisation: { organisationId } }) =>
      <RequestProvider
        requests={{
          getLandingPageAnalytics: getLandingPageAnalyticsQuery(organisationId)
        }}>

          {(requests) =>
        <SizeMe>
              {({ size: { width } = { width: 0 } }) =>
          <AnalyticsBannerComponent
            width={width}
            {...requests}
            {...props} />}


            </SizeMe>}

        </RequestProvider>}

    </AuthorisationConsumer>);

}

export default withRouter(AnalyticsBanner);